import React from 'react';
export type Config = Record<string, any>;

const AppConfigContext = React.createContext<Config>({});

interface Props {
  config: Config;
  children?: React.ReactNode;
}

export const AppConfigProvider: React.FC<Props> = ({ config, children }) => (
  <AppConfigContext.Provider value={config}>
    {children}
  </AppConfigContext.Provider>
);

export const useAppConfig = () => {
  const config = React.useContext(AppConfigContext);
  if (!config) {
    throw new Error('useAppConfig must be used within a AppConfigProvider');
  }
  return config;
};
